import services from './services.js';
import {
    cloneDeep,
    util,
    isCorrectVal,
    isDate,
    lg
} from 'utils';

export default {
    mixins: [services],
    props: {
        //是否隐藏区域
        areaIsHide: {
            default: false
        },
        label: {
            type: String,
            default: '所在区域'
        },
        labelWidth: {
            type: String,
            default: '90px'
        },
        value: {
            default: {
                Provinces_Id: null,
                City_Id: null,
                Area_Id: null
            }
        },
        required: {
            type: Boolean,
            default: false
        },
        width: {
            type: String,
            default: '87'
        },
        disabled: {
            type: Boolean,
            defualut: false
        },
        diabledProv: {
            type: Boolean,
            defualut: false
        },
        diabledCity: {
            type: Boolean,
            defualut: false
        },
        cityValue: {
            type: Boolean,
            defualut: false
        },
        myIndex: {
            default: 1
        },
        hasDelFn: {
            default: false
        },
        isReadOnly: {
            default: false
        }
    },
    data() {
        return {
            formShow: true,
            isClose: 0,
            isSelProvinceId: 0, //0，未选中；1选中；如果用户没有选中任何省，那么就阻止访问后台
            isSelCityId: 0, //0未选中，1选中；如果用户没有选中任何市，那么就阻止访问后台
            proLoading: false,
            cityLoading: false,
            areaLoading: false,
            provinceList: [], //省份列表
            cityList: [], //城市列表
            areaList: [], //区\县列表
            result: this.getResultData(),
            rules: {
                Provinces_Id: [{
                    validator: (rule, value, callback) => {
                        if ($.trim(value).length == 0) {
                            // this.$notify({
                            //     title: '警告',
                            //     message: '请选择省份',
                            //     type: 'warning'
                            // });
                            callback(new Error('请选择省份'));
                        } else {
                            callback();
                        }
                    },
                    trigger: 'blur'
                }],
                City_Id: [{
                    validator: (rule, value, callback) => {
                        if ($.trim(value).length == 0) {
                            this.$notify({
                                title: '警告',
                                message: '请选择城市',
                                type: 'warning'
                            });
                            callback(new Error('请选择城市'));
                        } else {
                            callback();
                        }
                    },
                    trigger: 'blur'
                }]
            },
            valid: false
        };
    },
    computed: {
        sysSid() {
            return this.$store.state.sysSid;
        },
        sysSession() {
            return this.$store.state.sysSession;
        },
        styleObj() {
            return {
                width: this.width + '%'
            };
        },
        getLabelWidth() {
            if ($.trim(this.label).length == 0) {
                return '0px';
            }
            return this.labelWidth;
        },
        hasDelBtnShow() {
            if (this.isReadOnly || this.myIndex == 1) {
                // 第一个不显示删除按钮
                return false;
            }
            if (!this.hasDelFn) {
                return false;
            }
            return true;
        },
    },
    watch: {
        'value.Provinces_Id': {
            deep: true,
            handler: function (curVal, oldVal) {
                //避免关闭的时候，又去访问后端数据
                this.initAreaSelect();
            }
        }
    },
    created() {
        this.isRequired = this.required;
        this.setValue();
        // this.getProvinces();
        this.initAreaSelect();
    },
    methods: {
        deletefn(index) {
            this.$emit('delAreafn', {
                index: index
            });
        },
        getResultData() {
            return cloneDeep({
                Provinces_Id: null,
                City_Id: null,
                Area_Id: null
            });
        },
        initAreaSelect() {
            //获取省份列表
            console.log(this.value)
            this.getProvinces({
                provincesId: this.value.Provinces_Id,
                successCallBack: () => {
                    this.getCity({
                        provincesId: this.value.Provinces_Id,
                        cityId: this.value.City_Id,
                        successCallBack: () => {
                            this.getArea({
                                cityId: this.value.City_Id,
                                areaId: this.value.Area_Id
                            });
                        }
                    });
                }
            });

        },
        selfChangeProvince(val) {
            this.isSelProvinceId = 1;

        },
        selfChangeCity(val) {
            this.isSelCityId = 1;
        },
        changeProvince(val) {
            if (val) {
                this.isSelProvinceId = 0;
            } else {
                if (this.isSelProvinceId == 0) {
                    return;
                }
                if (this.result.Provinces_Id == null) {
                    return;
                }
                this.getCity({
                    provincesId: this.result.Provinces_Id,
                    successCallBack: () => {
                        this.isSelProvinceId = 0;
                        this.getArea({
                            cityId: this.result.City_Id,
                            successCallBack: () => {
                                this.$emit('change', this.getSelectedData()); // 向上派发 toggle事件
                            }
                        });
                    }
                });
            }

        },
        changeCity(val) {
            if (val) {
                this.isSelCityId = 0;
            } else {
                if (this.isSelCityId == 0) {
                    return;
                }
                if (this.result.City_Id == null) {
                    return;
                }
                this.getArea({
                    cityId: this.result.City_Id,
                    successCallBack: () => {
                        this.$emit('change', this.getSelectedData()); // 向上派发 toggle事件
                    }
                });
            }
        },
        changeArea(val) {
            if (val !== '') {
                this.$emit('change', this.getSelectedData()); // 向上派发 toggle事件
            }
        },
        getCityFn(item) {
            this.resetCityArea();
        },
        getAreaFn(item) {
            this.resetCityArea();
        },
        resetCityArea() {

        },
        setValue() {
            if (!isCorrectVal(this.value)) return;
            this.result = cloneDeep(Object.assign({}, this.getResultData(), this.value));



        },
        //验证+获取数据
        validate() {

            this.$refs.form.validate(valid => {
                this.valid = valid;
            });
            if (this.valid) {
                if (this.areaIsHide) {
                    this.result.Area_Id = "";
                }
                return this.getSelectedData();
            }
            return false;
        },
        getSelectedData() {

            let areaName = {
                provName: "",
                cityName: "",
                areaName: ""
            };

            if ($.trim(this.result.Provinces_Id).length > 0 && this.provinceList.length > 0) {
                areaName.provName = util.getItemByIdInArr(this.result.Provinces_Id, this.provinceList, "Id").Name;
            }

            if ($.trim(this.result.City_Id).length > 0 && this.cityList.length > 0) {
                areaName.cityName = util.getItemByIdInArr(this.result.City_Id, this.cityList, "Id").Name;
            }

            if ($.trim(this.result.Area_Id).length > 0 && this.areaList.length > 0) {
                areaName.areaName = util.getItemByIdInArr(this.result.Area_Id, this.areaList, "Id").Name;
            }
            return Object.assign({}, this.result, areaName);
        },
        //获取数据
        getAreaData() {
            return this.result;
        },
        clearResultValue() {
            this.result = this.getResultData();
        },
        clearAreaData() {
            this.result.Area_Id = "";
        },
        resetFields() {
            // this.$refs.form.resetFields();
            this.isSelProvinceId = 0;
            this.isSelCityId = 0;
            this.isClose = 1;
            this.clearResultValue();
        }
    }
};


// WEBPACK FOOTER //
// ./src/common/components/area-select/vm.js